import { render, staticRenderFns } from "./wash.vue?vue&type=template&id=3823ee2a"
import script from "./wash.vue?vue&type=script&lang=js"
export * from "./wash.vue?vue&type=script&lang=js"
import style0 from "./wash.vue?vue&type=style&index=0&id=3823ee2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports